import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { readThrottleInfo, ThrottleNotice } from './throttle-notice';

/** Shows the throttle toast when an HttpClient call comes back 429 with a retry delay. */
@Injectable()
export class ThrottleInterceptor implements HttpInterceptor {
	constructor(private throttleNotice: ThrottleNotice) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError(error => {
				if (error instanceof HttpErrorResponse && error.status === 429) {
					const info = readThrottleInfo(error);
					if (info.penalty != null || info.ruleText) {
						this.throttleNotice.show(info);
					}
				}
				return throwError(error);
			})
		);
	}
}
